import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const TabRoute = ({ tab, children }) => {
  const { canAccessTab } = useAuth();
  if (canAccessTab(tab)) return children;
  return <section className="p-6 sm:p-8 space-y-3" data-testid={`access-denied-${tab.replace(/_/g, "-")}`} role="alert">
    <Shield size={28} className="text-slate-400" /><h1 className="text-xl font-semibold text-slate-900">Accès non autorisé</h1>
    <p className="text-sm text-slate-500">Cet onglet doit être autorisé par votre administrateur.</p>
    <Link to="/" className="inline-flex items-center min-h-11 text-sm text-[#26788A]" data-testid={`access-denied-${tab.replace(/_/g, "-")}-home`}>Retour à l’accueil</Link>
  </section>;
};